import { render, staticRenderFns } from "./exhibition-template-new-franchisee.vue?vue&type=template&id=00a5b99e&scoped=true&"
import script from "./exhibition-template-new-franchisee.vue?vue&type=script&lang=js&"
export * from "./exhibition-template-new-franchisee.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template-new-franchisee.vue?vue&type=style&index=0&id=00a5b99e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a5b99e",
  null
  
)

export default component.exports